import debounce from "lodash.debounce";

let counter = 0;
const update = debounce(function () {
    if (counter > 0) {
        document.body.classList.add("no-scroll");
    } else {
        setTimeout(function () {
            document.body.classList.remove("no-scroll");
        }, 500);
    }
}, 30);

export default {
    hideScroll() {
        counter++;
        update();
    },
    showScroll() {
        counter--;
        update();
    }
};
